export default "__VITE_ASSET__DYeHF$uT__"